import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import InstructionWrap from '../../../../components/InstructionWrap';

const DocumentChanges = ({ i18n }) => {
  const pricelist = [
    {
      label: i18n('rates.tab2.pricelist.1.title'),
      sub: i18n('rates.tab2.pricelist.1.subtitle'),
      price: i18n('rates.tab2.pricelist.1.price')
    },
    {
      label: i18n('rates.tab2.pricelist.2.title'),
      sub: i18n('rates.tab2.pricelist.2.subtitle'),
      price: i18n('rates.tab2.pricelist.2.price')
    }
  ];

  return (
    <div className='card-instruction-detail'>
      <div className='rates'>
        <span style={{ fontSize: 14 }}>{i18n('rates.info1')}</span>
        <div style={{ fontSize: 16, color: 'red' }}>{i18n('rates.info3')}</div>
      </div>
      <main>
        <InstructionWrap type='rates' rates={pricelist} />
      </main>
    </div>
  );
};

DocumentChanges.propTypes = {
  i18n: PropTypes.func
};

const mapStateToProps = (state) => ({
  i18n: state.langReducer.i18n
});

export default connect(mapStateToProps)(DocumentChanges);
